import React, { useState } from 'react';
import axios from 'axios';
import ReactMarkdown from 'react-markdown';

function APISixForm() {
  const [inputs, setInputs] = useState({
    brand_name: '',
    celeb_name: '',
    collab_details: ''
  });
  const [threadId, setThreadId] = useState('');
  const [chatHistory, setChatHistory] = useState([]);
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  const handleMessageChange = (e) => {
    setMessage(e.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    setErrorMessage('');
    try {
      const res = await axios.post(
        'https://ai-api.fuselight.com/create_thread',
        inputs,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      setThreadId(res.data.thread_id);
      setChatHistory([{ sender: 'bot', text: res.data.response }]);
    } catch (error) {
      console.error('Error creating thread:', error);
      setErrorMessage('Failed to create thread. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSendMessage = async (event) => {
    event.preventDefault();
    if (!threadId) {
      setErrorMessage('Thread not created yet. Please submit initial details first.');
      return;
    }
    setIsLoading(true);
    setErrorMessage('');
    try {
      const res = await axios.post(
        'https://ai-api.fuselight.com/send_message',
        {
          thread_id: threadId,
          message: message
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      setChatHistory([
        ...chatHistory,
        { sender: 'user', text: message },
        { sender: 'bot', text: res.data.response, image: res.data.imaage_url }
      ]);
      setMessage('');
    } catch (error) {
      console.error('Error sending message:', error);
      setErrorMessage('Failed to send message. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleReset = () => {
    window.location.reload();
  };

  return (
    <div className="chatbot-container">
      <form onSubmit={handleSubmit} className="initial-form">
        <div className="form-row">
          <input
            type="text"
            name="brand_name"
            value={inputs.brand_name}
            onChange={handleChange}
            placeholder="Brand Name"
            required
          />
          <input
            type="text"
            name="celeb_name"
            value={inputs.celeb_name}
            onChange={handleChange}
            placeholder="Celebrity Name"
            required
          />
        </div>
        <div className="form-row">
          <textarea
            name="collab_details"
            value={inputs.collab_details}
            onChange={handleChange}
            placeholder="Collab Idea"
            required
          />
        </div>
        <div className="form-row">
          <button type="submit">Submit</button>
        </div>
      </form>

      {threadId && (
        <>
          <div className="chat-history">
            {chatHistory.map((chat, index) => (
              <div key={index} className={`chat-message ${chat.sender}`}>
                <ReactMarkdown className='chat-text'>{chat.text}</ReactMarkdown>
                {chat.image && <img src={chat.image} alt="Bot generated" />}
              </div>
            ))}
              {isLoading && <div className="loading-message">Loading...</div>}
              {errorMessage && <div className="error-message">{errorMessage}</div>}
          </div>
          <form onSubmit={handleSendMessage} className="message-form">
            <div className="form-row">
              <input
                type="text"
                value={message}
                onChange={handleMessageChange}
                placeholder="Type your message"
                required
              />
            </div>
            <div className="form-row">
              <button type="submit">Send</button>
              <button onClick={handleReset}>Start New Conversation</button>
            </div>
          </form>
        </>
      )}
    </div>
  );
}

export default APISixForm;
